/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';

interface LocationScope extends IScope {
  sending: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  vehicle: AutoboardVehicle,
  newVehicleData: {
    location: string,
  },
  locations: { [key: string]: string },
}

/* @ngInject */
export default function LocationFormController(
  $scope: LocationScope,
  salesApiService: SalesAPIService,
  configService: ConfigService,
): void {
  $scope.sending = false;
  $scope.locations = configService.get('general_locations') || {};

  $scope.newVehicleData = {
    location: $scope.vehicle.vehicleData.inventory?.location || '',
  };

  $scope.exitForm = () => {
    $scope.exit({ removeLock: true });
  };

  $scope.formTransmission = async () => {
    $scope.sending = true;

    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: $scope.vehicle._id,
      vehicleData: {
        inventory: {
          location: $scope.newVehicleData.location,
          locationDescription: $scope.locations[$scope.newVehicleData.location],
        },
      },
    };

    await salesApiService.putVehicle(changedVals);
    return $scope.exit({});
  };
}
